import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import ActionMenu from './ActionMenu';
import DragHandle from './DragHandle';

function AppShortcutEdit({ app, section, icon, onEdit, onMove, onDelete, onSaveForLater }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: app.id, data: { type: 'app', sectionId: section.id } });

  const style = { transform: CSS.Transform.toString(transform), transition };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`app-shortcut app-shortcut-edit${isDragging ? ' is-dragging' : ''}`}
    >
      <DragHandle
        ref={setActivatorNodeRef}
        label={`Reorder ${app.name}`}
        {...attributes}
        {...listeners}
      />
      {icon}
      <span className="app-name">{app.name}</span>
      <span className="app-row-actions">
        <ActionMenu
          label={`Options for ${app.name}`}
          items={[
            { label: 'Edit', onSelect: onEdit },
            { label: 'Move to Section', onSelect: onMove },
            { label: 'Save for later', onSelect: onSaveForLater },
            { label: 'Delete', onSelect: onDelete, danger: true }
          ]}
        />
      </span>
    </div>
  );
}

export default AppShortcutEdit;